"use client";

import { useState, useEffect } from "react";
// Import Toaster directly instead of dynamic import to avoid webpack issues
import { Toaster } from "@/components/ui/toaster";

export default function ToasterClient() {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	// Don't render on server to prevent hydration mismatches
	if (!mounted) {
		return null;
	}

	return <Toaster />;
}

